import React, { useEffect, useMemo, useState } from "react";
import styled from "styled-components";

import LogoImage from "../assets/img/logo.jpeg";
import Banner1 from "../assets/img/bannerpc1-optimized.jpg";
import Banner2 from "../assets/img/bannerpc2-optimized.jpg";
import BannerMobile1 from "../assets/img/bannermobile1.png";
import BannerMobile2 from "../assets/img/bannermobile2.png";
import Meet1 from "../assets/img/meet1-optimized.jpg";
import Meet2 from "../assets/img/meet2-optimized.jpg";
import Meet3 from "../assets/img/meet3-optimized.jpg";
import Meet4 from "../assets/img/meet4-optimized.jpg";
import Album1 from "../assets/img/album1.jpeg";
import Album2 from "../assets/img/album2.jpeg";
import Album3 from "../assets/img/album3.jpeg";
import Album4 from "../assets/img/album4.jpeg";
import MangoLogo from "../assets/img/logo-mango.png";

import WppBtn from "../components/WppBtn";

import { ReactComponent as CardIcon } from "../assets/icons/card.svg";
import { ReactComponent as DeliveryIcon } from "../assets/icons/delivery.svg";
import { ReactComponent as ExchangeIcon } from "../assets/icons/exchange.svg";
import { ReactComponent as PixIcon } from "../assets/icons/pix.svg";
import { ReactComponent as SupportIcon } from "../assets/icons/support.svg";
import { ReactComponent as MenuIcon } from "../assets/icons/menu.svg";
import { ReactComponent as InstagramIcon } from "../assets/icons/instagram.svg";

const WHATSAPP_PHONE = "5584999284464";
const INSTAGRAM_URL = "https://www.instagram.com/jrfigurinhas";
const MAP_EMBED_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3969.151987604099!2d-35.22123182409597!3d-5.834187994149065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7b2559dbb25f467%3A0x6deff79cbea9c6e1!2sJR%20Figurinhas!5e0!3m2!1spt-BR!2sbr!4v1750085723384!5m2!1spt-BR!2sbr";
const WORLD_CUP_CAMPAIGN_ENABLED = true;
const WORLD_CUP_BANNER_DELAY_MS = 3000;
const WORLD_CUP_CONFETTI_RAIN_DURATION_MS = 14000;
const WORLD_CUP_BANNER_MESSAGE =
  "JR Figurinhas já está em clima de Copa com troca-troca de figurinhas todos os dias na banca.";

const navigationLinks = [
  { href: "#inicio", label: "Início" },
  { href: "#completos", label: "Álbuns completos" },
  { href: "#normais", label: "Álbuns normais" },
  { href: "#avulsas", label: "Figurinhas avulsas" },
  { href: "#encontro", label: "Encontro" },
];

const heroSlides = [
  {
    desktop: Banner1,
    mobile: BannerMobile1,
    alt: "Banner de JR Figurinhas convidando colecionadores a completar o álbum",
    badge: "Álbuns completos e atendimento rápido",
  },
  {
    desktop: Banner2,
    mobile: BannerMobile2,
    alt: "Banner de JR Figurinhas sobre colecionar figurinhas e construir memórias",
    badge: "Colecionismo que vira memória",
  },
];

const benefits = [
  {
    title: "Cartão e débito",
    description: "Pague com cartão na hora, sem complicação.",
    Icon: CardIcon,
  },
  {
    title: "Pix disponível",
    description: "Pix rápido para confirmar o pedido.",
    Icon: PixIcon,
  },
  {
    title: "Entrega ágil",
    description: "Receba o pedido com mais agilidade.",
    Icon: DeliveryIcon,
  },
  {
    title: "Troca em até 30 dias",
    description: "Mais segurança para comprar e trocar.",
    Icon: ExchangeIcon,
  },
  {
    title: "Atendimento humano",
    description: "Atendimento direto para tirar dúvidas da sua coleção.",
    Icon: SupportIcon,
  },
];

const teamAlbums = [
  {
    src: Album1,
    name: "Copa do Mundo de Clubes 2025",
    tabLabel: "Clubes 2025",
    description: "Álbum completo para quem quer levar a coleção pronta.",
  },
  {
    src: Album2,
    name: "Copa do Mundo 2018 (Rússia)",
    tabLabel: "Rússia 2018",
    description: "Edição procurada por quem coleciona Copas do Mundo.",
  },
  {
    src: Album3,
    name: "Copa do Mundo 2022 (Qatar)",
    tabLabel: "Qatar 2022",
    description: "Boa opção para fechar uma Copa recente sem esperar.",
  },
  {
    src: Album4,
    name: "Chapolin Colorado & Chaves",
    tabLabel: "Chaves & Chapolin",
    description: "Coleção especial para fãs dos personagens.",
  },
];
const roulettePalette = [
  {
    soft: "#fff4b5",
    strong: "#ffc93c",
    deep: "#8d5d00",
    glow: "rgba(255, 201, 60, 0.3)",
    card: "linear-gradient(180deg, rgba(255, 248, 210, 0.96), rgba(255, 224, 124, 0.92))",
  },
  {
    soft: "#cfefff",
    strong: "#57c7ff",
    deep: "#005d86",
    glow: "rgba(87, 199, 255, 0.28)",
    card: "linear-gradient(180deg, rgba(234, 248, 255, 0.96), rgba(159, 226, 255, 0.92))",
  },
  {
    soft: "#d7f7cf",
    strong: "#72d572",
    deep: "#1d6b2f",
    glow: "rgba(114, 213, 114, 0.28)",
    card: "linear-gradient(180deg, rgba(240, 255, 236, 0.96), rgba(188, 243, 177, 0.92))",
  },
  {
    soft: "#ffd6e5",
    strong: "#ff8fb1",
    deep: "#8b2f54",
    glow: "rgba(255, 143, 177, 0.28)",
    card: "linear-gradient(180deg, rgba(255, 241, 246, 0.96), rgba(255, 195, 216, 0.92))",
  },
];

const getAlbumPalette = (index = 0) =>
  roulettePalette[((index % roulettePalette.length) + roulettePalette.length) % roulettePalette.length];

const worldCupConfettiPieces = Array.from({ length: 20 }, (_, index) => ({
  left: `${4 + index * 4.7}%`,
  top: `${10 + (index % 5) * 4}%`,
  size: 8 + (index % 4) * 2,
  color: index % 2 === 0 ? "#72d572" : "#f7c015",
  drift: (index % 2 === 0 ? -1 : 1) * (26 + (index % 5) * 9),
  rotate: 100 + index * 18,
  duration: 2.55 + (index % 4) * 0.24,
  delay: `${(index % 6) * 0.05}s`,
  shape: index % 3 === 0 ? "circle" : "rect",
}));

const worldCupRainPieces = Array.from({ length: 32 }, (_, index) => ({
  left: `${2 + index * 3.05}%`,
  size: 10 + (index % 5) * 3,
  color: index % 2 === 0 ? "#72d572" : "#f7c015",
  drift: (index % 2 === 0 ? -1 : 1) * (18 + (index % 6) * 7),
  rotate: 140 + index * 16,
  duration: 4.8 + (index % 5) * 0.45,
  delay: `${(index % 8) * 0.18}s`,
  shape: index % 3 === 0 ? "circle" : "rect",
  opacity: 0.78 + (index % 3) * 0.08,
}));

const communityPhotos = [
  {
    src: Meet1,
    alt: "Colecionadores reunidos na banca trocando figurinhas em uma mesa grande",
    tall: true,
    label: "Mesa principal",
    note: "Troca de figurinhas acontecendo na banca.",
    accent: "#57c7ff",
    tilt: -2.4,
    offset: 8,
    duration: 7.8,
    delay: "-1.4s",
  },
  {
    src: Meet2,
    alt: "Público reunido em um encontro de JR Figurinhas",
    label: "Banca cheia",
    note: "Mais opções de troca e compra no mesmo lugar.",
    accent: "#ffc93c",
    tilt: 2.1,
    offset: 20,
    duration: 6.9,
    delay: "-0.8s",
  },
  {
    src: Meet3,
    alt: "Colecionadores sentados trocando figurinhas em um encontro de JR Figurinhas",
    label: "Famílias colecionando",
    note: "Espaço para famílias e colecionadores de todas as idades.",
    accent: "#72d572",
    tilt: -1.4,
    offset: -4,
    duration: 7.2,
    delay: "-2.1s",
  },
  {
    src: Meet4,
    alt: "Participantes reunidos no tradicional troca-troca de JR Figurinhas",
    wide: true,
    label: "Troca ao vivo",
    note: "Mais chances de encontrar as figurinhas que faltam.",
    accent: "#ff8fb1",
    tilt: 1.5,
    offset: 10,
    duration: 8.1,
    delay: "-1.7s",
  },
];

const buildWhatsAppLink = (message) =>
  `https://wa.me/${WHATSAPP_PHONE}?text=${encodeURIComponent(message)}`;

const openContactLink = buildWhatsAppLink(
  "Olá, vim através do site e quero saber mais sobre os produtos de JR Figurinhas."
);

const fullAlbumLink = buildWhatsAppLink(
  "Olá, vim através do site e quero saber quais álbuns completos estão disponíveis no momento."
);

const regularAlbumLink = buildWhatsAppLink(
  "Olá, vim através do site e quero saber quais álbuns vazios estão disponíveis no momento."
);

const singleStickerLink = buildWhatsAppLink(
  "Olá, vim através do site e quero comprar figurinhas avulsas. Vou enviar a lista do meu álbum para verificar a disponibilidade."
);

const meetupLink = buildWhatsAppLink(
  "Olá, vim através do site e quero saber mais sobre o troca-troca de figurinhas."
);

const worldCupQuestionsLink = buildWhatsAppLink(
  "Olá, vim através do banner da Copa no site e quero tirar dúvidas sobre o troca-troca de figurinhas."
);

const Page = styled.div`
  min-height: 100vh;
  background:
    radial-gradient(circle at top left, rgba(16, 152, 60, 0.14), transparent 30%),
    radial-gradient(circle at top right, rgba(247, 192, 21, 0.18), transparent 22%),
    linear-gradient(180deg, #f3f8ff 0%, #ffffff 22%, #eef4ff 100%);
  color: var(--text-primary);
`;

const Header = styled.header`
  position: fixed;
  inset: 0 0 auto;
  z-index: 50;
  padding: 0.85rem 1.25rem;
  transition: padding 0.25s ease, background-color 0.25s ease, box-shadow 0.25s ease,
    backdrop-filter 0.25s ease;
  background: ${({ $scrolled }) =>
    $scrolled
      ? "rgba(1, 19, 63, 0.9)"
      : "linear-gradient(180deg, rgba(243, 248, 255, 0.96), rgba(243, 248, 255, 0.84))"};
  box-shadow: ${({ $scrolled }) =>
    $scrolled ? "0 18px 40px rgba(0, 19, 63, 0.18)" : "none"};
  backdrop-filter: ${({ $scrolled }) => ($scrolled ? "blur(18px)" : "none")};
`;

const HeaderInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
`;

const BrandLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 1rem;
  color: ${({ $scrolled }) => ($scrolled ? "#ffffff" : "var(--brand-blue)")};
  text-decoration: none;
`;

const BrandLogo = styled.img`
  width: 5.25rem;
  height: 5.25rem;
  padding: 0.3rem;
  border-radius: 1.2rem;
  object-fit: contain;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.2);

  @media (max-width: 768px) {
    width: 4.5rem;
    height: 4.5rem;
  }
`;

const BrandText = styled.span`
  display: inline-flex;
  flex-direction: column;
  gap: 0.1rem;

  strong {
    font-size: 1.12rem;
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  small {
    color: ${({ $scrolled }) => ($scrolled ? "rgba(255, 255, 255, 0.78)" : "rgba(3, 37, 99, 0.72)")};
    font-size: 0.9rem;
  }

  @media (max-width: 640px) {
    display: none;
  }
`;

const DesktopNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 1.2rem;

  @media (max-width: 880px) {
    display: none;
  }
`;

const NavLink = styled.a`
  color: ${({ $scrolled }) => ($scrolled ? "rgba(255, 255, 255, 0.92)" : "rgba(3, 37, 99, 0.88)")};
  font-size: 0.95rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  text-decoration: none;

  &:hover {
    color: var(--brand-gold);
  }
`;

const MenuButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border: 1px solid ${({ $scrolled }) => ($scrolled ? "rgba(255, 255, 255, 0.24)" : "rgba(3, 37, 99, 0.14)")};
  border-radius: 1rem;
  background: ${({ $scrolled }) => ($scrolled ? "rgba(255, 255, 255, 0.08)" : "rgba(255, 255, 255, 0.72)")};
  color: ${({ $scrolled }) => ($scrolled ? "#ffffff" : "var(--brand-blue)")};
  cursor: pointer;

  @media (max-width: 880px) {
    display: inline-flex;
  }
`;

const MobileMenu = styled.div`
  position: fixed;
  inset: 0;
  z-index: 60;
  padding: 1.25rem;
  display: flex;
  justify-content: flex-end;
  background: ${({ $open }) => ($open ? "rgba(3, 11, 34, 0.56)" : "transparent")};
  opacity: ${({ $open }) => ($open ? "1" : "0")};
  pointer-events: ${({ $open }) => ($open ? "auto" : "none")};
  transition: opacity 0.25s ease, background 0.25s ease;
`;

const MobileMenuPanel = styled.div`
  width: min(22rem, 100%);
  padding: 1.35rem;
  border-radius: 1.75rem;
  background: linear-gradient(180deg, rgba(0, 40, 120, 0.98), rgba(2, 21, 72, 0.98));
  box-shadow: 0 24px 60px rgba(1, 19, 63, 0.3);
  transform: ${({ $open }) => ($open ? "translateX(0)" : "translateX(2rem)")};
  transition: transform 0.25s ease;
`;

const MobileMenuTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1.25rem;
  color: #ffffff;

  strong {
    font-size: 0.95rem;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }
`;

const CloseButton = styled.button`
  width: 2.8rem;
  height: 2.8rem;
  border: 0;
  border-radius: 0.95rem;
  background: rgba(255, 255, 255, 0.12);
  color: #ffffff;
  font-size: 1.25rem;
  cursor: pointer;
`;

const MobileNav = styled.nav`
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
`;

const MobileNavLink = styled.a`
  display: block;
  padding: 0.95rem 1rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  font-weight: 600;
  text-decoration: none;
`;

const Main = styled.main`
  display: block;
`;

const HeroCarouselSection = styled.section`
  position: relative;
  padding: 6.9rem 1.25rem 0;

  @media (max-width: 768px) {
    padding-top: 6.2rem;
  }
`;

const HeroCarouselInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const HeroSection = styled.section`
  position: relative;
  overflow: hidden;
  padding: 2rem 1.25rem 4.5rem;

  &::before {
    content: "";
    position: absolute;
    width: 36rem;
    height: 36rem;
    left: -10rem;
    top: -8rem;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(247, 192, 21, 0.24), transparent 68%);
    pointer-events: none;
  }

  &::after {
    content: "";
    position: absolute;
    width: 28rem;
    height: 28rem;
    right: -6rem;
    bottom: -10rem;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(0, 40, 120, 0.18), transparent 66%);
    pointer-events: none;
  }

  @media (max-width: 768px) {
    padding-top: 1.5rem;
  }
`;

const HeroInner = styled.div`
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
`;

const HeroCopy = styled.div`
  max-width: 42rem;
`;

const Eyebrow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: rgba(0, 40, 120, 0.08);
  color: var(--brand-blue);
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const HeroTitle = styled.h1`
  margin: 1.2rem 0 1rem;
  color: var(--brand-blue);
  font-size: clamp(2.9rem, 7vw, 5.3rem);
  font-weight: 800;
  line-height: 0.92;
  text-transform: uppercase;
  letter-spacing: 0.01em;
`;

const HeroText = styled.p`
  margin: 0;
  max-width: 34rem;
  color: var(--text-secondary);
  font-size: 1.12rem;
  line-height: 1.65;
`;

const HeroList = styled.ul`
  margin: 1.35rem 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.75rem;
`;

const HeroListItem = styled.li`
  display: inline-flex;
  align-items: flex-start;
  gap: 0.75rem;
  color: var(--text-primary);
  font-size: 1rem;
  line-height: 1.5;

  &::before {
    content: "";
    display: inline-block;
    width: 0.85rem;
    height: 0.85rem;
    margin-top: 0.25rem;
    border-radius: 999px;
    background: linear-gradient(135deg, var(--brand-gold), #ffd84f);
    box-shadow: 0 0 0 6px rgba(247, 192, 21, 0.16);
    flex-shrink: 0;
  }
`;

const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.95rem;
  margin-top: 1.75rem;
`;

const ButtonLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 3.35rem;
  padding: 0.9rem 1.35rem;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.98rem;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  text-decoration: none;
  transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease,
    background-color 0.22s ease, color 0.22s ease;
  background: ${({ $variant }) =>
    $variant === "light"
      ? "#ffffff"
      : $variant === "outline"
        ? "rgba(255, 255, 255, 0.75)"
        : "linear-gradient(135deg, var(--brand-blue), #0c4fb6)"};
  color: ${({ $variant }) =>
    $variant === "light" || $variant === "outline" ? "var(--brand-blue)" : "var(--brand-gold)"};
  border-color: ${({ $variant }) =>
    $variant === "outline" ? "rgba(0, 40, 120, 0.16)" : "transparent"};
  box-shadow: ${({ $variant }) =>
    $variant === "primary"
      ? "0 18px 34px rgba(0, 40, 120, 0.24)"
      : "0 14px 28px rgba(9, 34, 74, 0.08)"};

  &:hover {
    transform: translateY(-2px);
    color: ${({ $variant }) =>
      $variant === "light" || $variant === "outline" ? "var(--brand-blue)" : "var(--brand-gold)"};
    box-shadow: ${({ $variant }) =>
      $variant === "primary"
        ? "0 22px 40px rgba(0, 40, 120, 0.28)"
        : "0 18px 32px rgba(9, 34, 74, 0.12)"};
  }
`;

const HeroMeta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 1.45rem;
`;

const MetaPill = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 2.5rem;
  padding: 0.55rem 0.95rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 40, 120, 0.08);
  color: var(--text-primary);
  font-size: 0.9rem;
  font-weight: 600;
  box-shadow: 0 12px 22px rgba(9, 34, 74, 0.06);
`;

const HeroVisual = styled.div`
  display: grid;
  gap: 1rem;
  width: 100%;
`;

const HeroFrame = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 1.8rem;
  box-shadow: 0 24px 50px rgba(9, 34, 74, 0.16);
`;

const HeroMedia = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  aspect-ratio: 1440 / 588;
  background: linear-gradient(135deg, #0a8f39 0%, #0d6f2e 100%);

  @media (max-width: 768px) {
    aspect-ratio: 330 / 500;
  }
`;

const HeroSlide = styled.div`
  position: absolute;
  inset: 0;
  opacity: ${({ $active }) => ($active ? "1" : "0")};
  transform: ${({ $active }) => ($active ? "scale(1)" : "scale(1.04)")};
  transition: opacity 0.55s ease, transform 0.55s ease;
`;

const HeroPicture = styled.picture`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const HeroImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const HeroBadge = styled.span`
  position: absolute;
  left: 1.45rem;
  bottom: 1.45rem;
  display: inline-flex;
  align-items: center;
  min-height: 2.45rem;
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  background: rgba(0, 20, 62, 0.78);
  color: #ffffff;
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  backdrop-filter: blur(12px);
`;

const HeroDots = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.55rem;
  padding: 0 1.25rem;
`;

const HeroDot = styled.button`
  width: ${({ $active }) => ($active ? "2.2rem" : "0.8rem")};
  height: 0.8rem;
  border: 0;
  border-radius: 999px;
  background: ${({ $active }) =>
    $active ? "var(--brand-blue)" : "rgba(0, 40, 120, 0.16)"};
  cursor: pointer;
  transition: width 0.22s ease, background-color 0.22s ease;
`;

const Section = styled.section`
  padding: 0 1.25rem 5rem;
`;

const SectionInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
`;

const SectionHeading = styled.div`
  max-width: 44rem;
  margin-bottom: 2rem;
  color: ${({ $light }) => ($light ? "#ffffff" : "inherit")};
`;

const SectionTag = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 2.2rem;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  background: ${({ $light }) =>
    $light ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 40, 120, 0.08)"};
  color: ${({ $light }) => ($light ? "#ffffff" : "var(--brand-blue)")};
  font-size: 0.84rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const SectionTitle = styled.h2`
  margin: 0.95rem 0 0.8rem;
  font-size: clamp(2.1rem, 4.8vw, 3.6rem);
  line-height: 0.98;
  font-weight: 800;
  text-transform: uppercase;
  color: ${({ $light }) => ($light ? "#ffffff" : "var(--brand-blue)")};
`;

const SectionDescription = styled.p`
  margin: 0;
  color: ${({ $light }) =>
    $light ? "rgba(255, 255, 255, 0.82)" : "var(--text-secondary)"};
  font-size: 1.05rem;
  line-height: 1.7;
`;

const BenefitsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 560px) {
    grid-template-columns: 1fr;
  }
`;

const BenefitCard = styled.article`
  padding: 1.35rem;
  border-radius: 1.6rem;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(0, 40, 120, 0.08);
  box-shadow: 0 20px 34px rgba(9, 34, 74, 0.08);
`;

const BenefitIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  border-radius: 1.2rem;
  background: linear-gradient(135deg, rgba(0, 40, 120, 0.08), rgba(16, 152, 60, 0.12));
  color: var(--brand-blue);
`;

const BenefitTitle = styled.h3`
  margin: 1rem 0 0.45rem;
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--brand-blue);
`;

const BenefitText = styled.p`
  margin: 0;
  color: var(--text-secondary);
  font-size: 0.98rem;
  line-height: 1.55;
`;

const FeatureShell = styled.div`
  position: relative;
  overflow: visible;
  padding: 2rem;
  border-radius: 2.25rem;
  background: linear-gradient(135deg, #002878 0%, #0b449e 54%, #0f9142 100%);
  box-shadow: 0 32px 80px rgba(0, 40, 120, 0.22);

  &::before {
    content: "";
    position: absolute;
    inset: auto -7rem -9rem auto;
    width: 22rem;
    height: 22rem;
    border-radius: 999px;
    background: radial-gradient(circle, rgba(247, 192, 21, 0.34), transparent 70%);
  }

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const FeatureGrid = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(0, 0.92fr) minmax(0, 1.08fr);
  gap: 1.25rem;
  align-items: center;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureScrollArea = styled.div`
  margin-top: 1.35rem;
`;

const FeatureStickyShell = styled.div`
  position: relative;
`;

const AlbumPreview = styled.article`
  display: flex;
  flex-direction: column;
  gap: 1.15rem;
  padding: 1.35rem;
  border-radius: 1.8rem;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.16);
  color: #ffffff;
`;

const AlbumPreviewLabel = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  min-height: 2rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.12);
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const AlbumPreviewTitle = styled.h3`
  margin: 0;
  font-size: clamp(1.8rem, 4vw, 2.6rem);
  line-height: 0.98;
  text-transform: uppercase;
`;

const AlbumPreviewText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 1rem;
  line-height: 1.65;
`;

const AlbumPreviewMedia = styled.div`
  overflow: hidden;
  border-radius: 1.5rem;
  background: rgba(255, 255, 255, 0.1);
  aspect-ratio: 4 / 5;
`;

const AlbumPreviewImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AlbumSelector = styled.div`
  display: grid;
  gap: 1rem;
  align-content: start;
  padding-left: 1.4rem;

  @media (max-width: 980px) {
    padding-left: 0;
  }
`;

const AlbumSelectorIntro = styled.div`
  display: grid;
  gap: 0.55rem;
  justify-items: start;
`;

const AlbumSelectorTag = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 2rem;
  padding: 0.28rem 0.75rem;
  border-radius: 999px;
  background: ${({ $palette }) => $palette.soft};
  color: ${({ $palette }) => $palette.deep};
  font-size: 0.76rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const AlbumSelectorTitle = styled.h3`
  margin: 0;
  color: #ffffff;
  font-size: clamp(1.6rem, 3.2vw, 2.3rem);
  line-height: 1.02;
  text-transform: uppercase;
`;

const AlbumSelectorText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.98rem;
  line-height: 1.65;
`;

const AlbumOptions = styled.div`
  display: grid;
  gap: 0.85rem;
`;

const AlbumOption = styled.button`
  display: grid;
  grid-template-columns: auto 4.8rem minmax(0, 1fr);
  align-items: center;
  gap: 0.85rem;
  width: 100%;
  padding: 0.9rem;
  border-radius: 1.5rem;
  border: 1px solid
    ${({ $active }) => ($active ? "transparent" : "rgba(255, 255, 255, 0.16)")};
  background: ${({ $active, $palette }) =>
    $active ? $palette.card : "rgba(255, 255, 255, 0.1)"};
  color: ${({ $active, $palette }) => ($active ? $palette.deep : "#ffffff")};
  box-shadow: ${({ $active, $palette }) =>
    $active
      ? `0 20px 32px ${$palette.glow}, 0 0 0 3px rgba(255, 255, 255, 0.08)`
      : "0 14px 28px rgba(0, 0, 0, 0.12)"};
  text-align: left;
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease, color 0.2s ease;

  &:hover {
    transform: translateY(-2px);
  }

  @media (max-width: 560px) {
    grid-template-columns: auto 4rem minmax(0, 1fr);
    padding: 0.8rem;
  }
`;

const AlbumOptionNumber = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.9rem;
  height: 1.9rem;
  padding: 0 0.4rem;
  border-radius: 999px;
  background: ${({ $active, $palette }) =>
    $active ? "rgba(255, 255, 255, 0.78)" : $palette.soft};
  color: ${({ $palette }) => $palette.deep};
  font-size: 0.74rem;
  font-weight: 800;
`;

const AlbumOptionThumb = styled.div`
  overflow: hidden;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.78);
  aspect-ratio: 4 / 5;
`;

const AlbumOptionImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const AlbumOptionContent = styled.span`
  display: grid;
  gap: 0.22rem;
  min-width: 0;
`;

const AlbumOptionName = styled.span`
  font-size: 0.98rem;
  font-weight: 800;
  line-height: 1.35;
`;

const AlbumOptionDescription = styled.span`
  color: ${({ $active }) => ($active ? "rgba(3, 37, 99, 0.78)" : "rgba(255, 255, 255, 0.78)")};
  font-size: 0.86rem;
  line-height: 1.5;
`;

const AlbumSelectorFoot = styled.div`
  display: grid;
  gap: 0.4rem;
  justify-items: start;
`;

const AlbumSelectorFootLabel = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 1.95rem;
  padding: 0.25rem 0.72rem;
  border-radius: 999px;
  background: ${({ $palette }) => $palette.soft};
  color: ${({ $palette }) => $palette.deep};
  font-size: 0.74rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const AlbumSelectorFootText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: 0.92rem;
  line-height: 1.55;
`;

const OfferGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 1rem;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const OfferCard = styled.article`
  position: relative;
  overflow: hidden;
  min-height: 100%;
  padding: 1.75rem;
  border-radius: 2rem;
  background: ${({ $tone }) =>
    $tone === "dark"
      ? "linear-gradient(160deg, #03205f 0%, #0840a0 52%, #0b8c3f 100%)"
      : "linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(244, 248, 255, 0.96))"};
  color: ${({ $tone }) => ($tone === "dark" ? "#ffffff" : "var(--text-primary)")};
  border: 1px solid
    ${({ $tone }) =>
      $tone === "dark" ? "rgba(255, 255, 255, 0.14)" : "rgba(0, 40, 120, 0.08)"};
  box-shadow: 0 24px 54px rgba(9, 34, 74, 0.1);

  &::before {
    content: "";
    position: absolute;
    right: -3rem;
    top: -3rem;
    width: 11rem;
    height: 11rem;
    border-radius: 999px;
    background: ${({ $tone }) =>
      $tone === "dark"
        ? "rgba(247, 192, 21, 0.18)"
        : "rgba(247, 192, 21, 0.14)"};
  }
`;

const OfferContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const OfferTag = styled(SectionTag)`
  align-self: flex-start;
`;

const OfferTitle = styled.h3`
  margin: 1rem 0 0.7rem;
  font-size: clamp(1.7rem, 3vw, 2.35rem);
  line-height: 1;
  text-transform: uppercase;
  color: ${({ $tone }) => ($tone === "dark" ? "#ffffff" : "var(--brand-blue)")};
`;

const OfferText = styled.p`
  margin: 0;
  color: ${({ $tone }) =>
    $tone === "dark" ? "rgba(255, 255, 255, 0.82)" : "var(--text-secondary)"};
  font-size: 1rem;
  line-height: 1.68;
`;

const OfferList = styled.ul`
  margin: 1.2rem 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.65rem;
`;

const OfferListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 0.65rem;
  color: ${({ $tone }) =>
    $tone === "dark" ? "rgba(255, 255, 255, 0.92)" : "var(--text-primary)"};
  font-size: 0.98rem;

  &::before {
    content: "";
    width: 0.68rem;
    height: 0.68rem;
    border-radius: 999px;
    background: var(--brand-gold);
    flex-shrink: 0;
  }
`;

const OfferAction = styled.div`
  margin-top: auto;
  padding-top: 1.5rem;
`;

const CommunityGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.96fr) minmax(0, 1.04fr);
  gap: 1.25rem;
  align-items: stretch;

  @media (max-width: 980px) {
    grid-template-columns: 1fr;
  }
`;

const CommunityCard = styled.article`
  padding: 1.85rem;
  border-radius: 2rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(240, 246, 255, 0.94));
  border: 1px solid rgba(0, 40, 120, 0.08);
  box-shadow: 0 24px 54px rgba(9, 34, 74, 0.08);
`;

const CommunityHighlights = styled.ul`
  margin: 1.4rem 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.85rem;
`;

const CommunityHighlight = styled.li`
  display: flex;
  align-items: flex-start;
  gap: 0.8rem;
  color: var(--text-primary);
  font-size: 1rem;
  line-height: 1.55;

  strong {
    color: var(--brand-blue);
  }

  &::before {
    content: "";
    width: 2.1rem;
    height: 2.1rem;
    border-radius: 999px;
    background:
      radial-gradient(circle at center, rgba(247, 192, 21, 0.55) 0 34%, transparent 36%),
      rgba(0, 40, 120, 0.08);
    flex-shrink: 0;
  }
`;

const CommunityGallery = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: minmax(0, 1.02fr) minmax(0, 0.98fr);
  grid-template-rows: minmax(13rem, 16rem) minmax(13rem, 16rem) minmax(10rem, auto);
  gap: 1rem;

  @media (max-width: 620px) {
    grid-template-columns: 1fr;
    grid-template-rows: none;
  }
`;

const CommunityGalleryShell = styled.div`
  position: relative;
  padding: 1rem;
  border-radius: 2.2rem;
  background:
    radial-gradient(circle at 18% 18%, rgba(87, 199, 255, 0.18), transparent 24%),
    radial-gradient(circle at 82% 14%, rgba(255, 201, 60, 0.18), transparent 20%),
    radial-gradient(circle at 74% 78%, rgba(255, 143, 177, 0.16), transparent 20%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(240, 246, 255, 0.9));
  border: 1px solid rgba(0, 40, 120, 0.08);
  box-shadow: 0 24px 54px rgba(9, 34, 74, 0.1);
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background-image: radial-gradient(rgba(0, 40, 120, 0.08) 1px, transparent 1px);
    background-size: 18px 18px;
    opacity: 0.22;
    pointer-events: none;
  }
`;

const CommunityGalleryBadge = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 3;
  display: inline-flex;
  align-items: center;
  min-height: 2.35rem;
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.9);
  color: var(--brand-blue);
  font-size: 0.78rem;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  box-shadow: 0 14px 28px rgba(9, 34, 74, 0.12);
  animation: communityBadgeFloat 5.4s ease-in-out infinite;

  @keyframes communityBadgeFloat {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-5px);
    }
  }

  @media (max-width: 620px) {
    position: static;
    margin-bottom: 0.75rem;
    width: fit-content;
  }
`;

const CommunityPhoto = styled.figure`
  --community-offset: ${({ $offset = 0 }) => `${$offset}px`};
  --community-tilt: ${({ $tilt = 0 }) => `${$tilt}deg`};
  margin: 0;
  position: relative;
  overflow: hidden;
  padding: 0.5rem;
  border-radius: 1.8rem;
  background: rgba(255, 255, 255, 0.88);
  border: 1px solid rgba(255, 255, 255, 0.72);
  box-shadow:
    0 24px 46px rgba(9, 34, 74, 0.12),
    0 0 0 1px rgba(255, 255, 255, 0.45);
  min-height: 14rem;
  grid-row: ${({ $tall }) => ($tall ? "span 2" : "span 1")};
  grid-column: ${({ $wide }) => ($wide ? "span 2" : "span 1")};
  aspect-ratio: ${({ $tall, $wide }) =>
    $tall ? "4 / 5" : $wide ? "16 / 10" : "16 / 10"};
  transform: translateY(var(--community-offset)) rotate(var(--community-tilt));
  animation: communityPhotoFloat ${({ $duration = 7.2 }) => `${$duration}s`} ease-in-out infinite;
  animation-delay: ${({ $delay = "0s" }) => $delay};
  transition: transform 0.28s ease, box-shadow 0.28s ease;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: inherit;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.34), transparent 32%);
    pointer-events: none;
    z-index: 2;
  }

  &:hover {
    transform: translateY(calc(var(--community-offset) - 4px)) rotate(var(--community-tilt)) scale(1.015);
    box-shadow:
      0 28px 54px rgba(9, 34, 74, 0.16),
      0 0 0 1px rgba(255, 255, 255, 0.55);
  }

  &:hover img {
    transform: scale(1.04);
  }

  @keyframes communityPhotoFloat {
    0%,
    100% {
      transform: translateY(var(--community-offset)) rotate(var(--community-tilt));
    }
    50% {
      transform: translateY(calc(var(--community-offset) - 10px)) rotate(var(--community-tilt));
    }
  }

  @media (max-width: 620px) {
    grid-row: span 1;
    grid-column: span 1;
    aspect-ratio: ${({ $tall }) => ($tall ? "4 / 5" : "16 / 10")};
    transform: none;
    animation: none;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    transform: none;
  }
`;

const CommunityPhotoSurface = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 1.35rem;
  background: #dfe8f8;
`;

const CommunityImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform: scale(1.01);
  transition: transform 0.45s ease;
`;

const CommunityPhotoCaption = styled.figcaption`
  position: absolute;
  left: 0.95rem;
  right: 0.95rem;
  bottom: 0.95rem;
  z-index: 3;
  display: grid;
  gap: 0.45rem;
  padding: 0.85rem 0.95rem;
  border-radius: 1.15rem;
  background: rgba(3, 24, 74, 0.66);
  color: #ffffff;
  backdrop-filter: blur(12px);
`;

const CommunityPhotoLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  justify-self: start;
  min-height: 1.8rem;
  padding: 0.2rem 0.65rem;
  border-radius: 999px;
  background: ${({ $accent }) => $accent};
  color: #07224f;
  font-size: 0.72rem;
  font-weight: 800;
  letter-spacing: 0.07em;
  text-transform: uppercase;
`;

const CommunityPhotoNote = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.88);
  font-size: 0.92rem;
  font-weight: 600;
  line-height: 1.45;
`;

const WorldCupOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 95;
  background: rgba(2, 16, 48, 0.56);
  backdrop-filter: blur(10px);
`;

const WorldCupOverlayCenter = styled.div`
  position: fixed;
  inset: 0;
  z-index: 97;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.25rem;
  pointer-events: none;
`;

const WorldCupDialog = styled.div`
  position: relative;
  width: min(100%, 40rem);
  padding: 0.75rem;
  border-radius: 2rem;
  background:
    linear-gradient(135deg, #10983c 0%, #10983c 32%, #f7c015 32%, #f7c015 66%, #0c4fb6 66%, #0c4fb6 100%);
  box-shadow: 0 36px 80px rgba(1, 19, 63, 0.34);
  overflow: hidden;
  pointer-events: auto;
  animation: worldCupBannerIn 0.55s cubic-bezier(0.2, 0.9, 0.26, 1) both;

  @keyframes worldCupBannerIn {
    0% {
      opacity: 0;
      transform: translateY(28px) scale(0.96);
    }
    100% {
      opacity: 1;
      transform: translateY(0) scale(1);
    }
  }
`;

const WorldCupContent = styled.div`
  position: relative;
  z-index: 2;
  padding: 1.45rem 1.3rem 1.25rem;
  border-radius: 1.45rem;
  background:
    radial-gradient(circle at top right, rgba(87, 199, 255, 0.18), transparent 28%),
    radial-gradient(circle at bottom left, rgba(114, 213, 114, 0.18), transparent 26%),
    linear-gradient(180deg, rgba(255, 255, 255, 0.97), rgba(246, 250, 255, 0.94));
  color: var(--brand-blue);
  overflow: hidden;
`;

const WorldCupCloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 3;
  width: 2.7rem;
  height: 2.7rem;
  border: 0;
  border-radius: 999px;
  background: rgba(12, 79, 182, 0.12);
  color: var(--brand-blue);
  font-size: 1.1rem;
  cursor: pointer;
`;

const WorldCupBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 2.15rem;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  background: linear-gradient(90deg, #10983c 0%, #f7c015 52%, #0c4fb6 100%);
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  box-shadow: 0 14px 26px rgba(12, 79, 182, 0.18);
`;

const WorldCupTitle = styled.h3`
  margin: 1rem 0 0.7rem;
  color: var(--brand-blue);
  font-size: clamp(2rem, 5vw, 2.8rem);
  font-weight: 800;
  line-height: 0.95;
  text-transform: uppercase;
`;

const WorldCupText = styled.p`
  margin: 0;
  max-width: 30rem;
  color: var(--text-primary);
  font-size: 1.02rem;
  line-height: 1.65;
`;

const WorldCupActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.85rem;
  margin-top: 1.35rem;
`;

const WorldCupDismissButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 3.15rem;
  padding: 0.8rem 1.15rem;
  border: 1px solid rgba(0, 40, 120, 0.14);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.88);
  color: var(--brand-blue);
  font-size: 0.95rem;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 14px 28px rgba(9, 34, 74, 0.08);
`;

const WorldCupConfettiLayer = styled.div`
  position: absolute;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
`;

const WorldCupRainLayer = styled.div`
  position: fixed;
  inset: 0;
  z-index: 96;
  overflow: hidden;
  pointer-events: none;
`;

const WorldCupConfetti = styled.span`
  --confetti-drift: ${({ $drift }) => `${$drift}px`};
  --confetti-rotate: ${({ $rotate }) => `${$rotate}deg`};
  position: absolute;
  top: ${({ $top }) => $top};
  left: ${({ $left }) => $left};
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${Math.round($size * 1.9)}px`};
  border-radius: ${({ $shape }) => ($shape === "circle" ? "999px" : "4px")};
  background: ${({ $color }) => $color};
  box-shadow: 0 8px 14px rgba(0, 0, 0, 0.08);
  opacity: 0;
  transform: translate3d(0, -18px, 0) rotate(0deg) scale(0.35);
  animation: worldCupConfettiBurst ${({ $duration }) => `${$duration}s`} cubic-bezier(0.18, 0.9, 0.32, 1)
    forwards;
  animation-delay: ${({ $delay }) => $delay};

  @keyframes worldCupConfettiBurst {
    0% {
      opacity: 0;
      transform: translate3d(0, -18px, 0) rotate(0deg) scale(0.35);
    }
    12% {
      opacity: 1;
    }
    100% {
      opacity: 0;
      transform: translate3d(var(--confetti-drift), 240px, 0) rotate(var(--confetti-rotate)) scale(1);
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    opacity: 0.9;
    transform: none;
  }
`;

const WorldCupRainConfetti = styled.span`
  --rain-drift: ${({ $drift }) => `${$drift}px`};
  --rain-rotate: ${({ $rotate }) => `${$rotate}deg`};
  position: absolute;
  top: -12vh;
  left: ${({ $left }) => $left};
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${Math.round($size * 1.9)}px`};
  border-radius: ${({ $shape }) => ($shape === "circle" ? "999px" : "4px")};
  background: ${({ $color }) => $color};
  opacity: ${({ $opacity = 0.9 }) => $opacity};
  box-shadow: 0 8px 14px rgba(0, 0, 0, 0.08);
  animation: worldCupRainFall ${({ $duration }) => `${$duration}s`} linear infinite;
  animation-delay: ${({ $delay }) => $delay};

  @keyframes worldCupRainFall {
    0% {
      transform: translate3d(0, -14vh, 0) rotate(0deg);
    }
    100% {
      transform: translate3d(var(--rain-drift), 114vh, 0) rotate(var(--rain-rotate));
    }
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
    display: none;
  }
`;

const Footer = styled.footer`
  padding: 0 1.25rem 2.4rem;
`;

const FooterInner = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  border-radius: 2.2rem;
  background: linear-gradient(180deg, #021846 0%, #032563 100%);
  color: #ffffff;
  box-shadow: 0 26px 66px rgba(0, 19, 63, 0.24);

  @media (max-width: 768px) {
    padding: 1.5rem;
  }
`;

const FooterGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 0.9fr) minmax(0, 0.9fr) minmax(0, 1.2fr);
  gap: 1.5rem;

  @media (max-width: 1050px) {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;

const FooterBlock = styled.div`
  min-width: 0;
`;

const FooterTitle = styled.h3`
  margin: 0 0 0.8rem;
  font-size: 1.15rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

const FooterText = styled.p`
  margin: 0;
  color: rgba(255, 255, 255, 0.78);
  font-size: 0.98rem;
  line-height: 1.65;
`;

const FooterList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 0.55rem;
`;

const FooterItem = styled.li`
  color: rgba(255, 255, 255, 0.82);
  font-size: 0.96rem;
  line-height: 1.55;

  a {
    color: #ffffff;
  }
`;

const FooterNav = styled.nav`
  display: grid;
  gap: 0.55rem;

  a {
    color: rgba(255, 255, 255, 0.82);
    font-size: 0.96rem;
    text-decoration: none;
  }

  a:hover {
    color: var(--brand-gold);
  }
`;

const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3rem;
  height: 3rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
`;

const MapFrame = styled.iframe`
  width: 100%;
  min-height: 14rem;
  border: 0;
  border-radius: 1.4rem;
`;

const FooterBottom = styled.p`
  margin: 1.5rem 0 0;
  color: rgba(255, 255, 255, 0.64);
  font-size: 0.92rem;
  line-height: 1.55;
  text-align: center;
`;

const FooterSignatureLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-left: 0.35rem;
  vertical-align: middle;
`;

const FooterSignatureLogo = styled.img`
  width: auto;
  height: 1.8rem;
`;

function Home() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeHero, setActiveHero] = useState(0);
  const [activeAlbum, setActiveAlbum] = useState(0);
  const [isWorldCupBannerOpen, setIsWorldCupBannerOpen] = useState(false);
  const [isWorldCupConfettiRainActive, setIsWorldCupConfettiRainActive] = useState(false);

  const selectedAlbum = useMemo(() => teamAlbums[activeAlbum], [activeAlbum]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 24);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setActiveHero((current) => (current + 1) % heroSlides.length);
    }, 5200);

    return () => {
      window.clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    if (!WORLD_CUP_CAMPAIGN_ENABLED) {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      setIsWorldCupBannerOpen(true);
      setIsWorldCupConfettiRainActive(true);
    }, WORLD_CUP_BANNER_DELAY_MS);

    return () => {
      window.clearTimeout(timerId);
    };
  }, []);

  useEffect(() => {
    if (!isWorldCupConfettiRainActive) {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      setIsWorldCupConfettiRainActive(false);
    }, WORLD_CUP_CONFETTI_RAIN_DURATION_MS);

    return () => {
      window.clearTimeout(timerId);
    };
  }, [isWorldCupConfettiRainActive]);

  useEffect(() => {
    if (!isWorldCupBannerOpen) {
      return undefined;
    }

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setIsWorldCupBannerOpen(false);
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [isWorldCupBannerOpen]);

  useEffect(() => {
    document.body.style.overflow = menuOpen || isWorldCupBannerOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [isWorldCupBannerOpen, menuOpen]);

  const closeMenu = () => setMenuOpen(false);
  const closeWorldCupBanner = () => setIsWorldCupBannerOpen(false);
  const activeAlbumPalette = getAlbumPalette(activeAlbum);
  const meetupCampaignBadge = WORLD_CUP_CAMPAIGN_ENABLED ? "Especial Copa" : "Todo sábado";
  const meetupCampaignHighlightLabel = WORLD_CUP_CAMPAIGN_ENABLED ? "Campanha:" : "Horário:";
  const meetupCampaignHighlightText = WORLD_CUP_CAMPAIGN_ENABLED
    ? "troca-troca de figurinhas todos os dias na banca."
    : "sábados, das 08h30 às 14h.";

  const selectAlbum = (index) => {
    setActiveAlbum(index);
  };

  return (
    <Page>
      <Header $scrolled={isScrolled}>
        <HeaderInner>
          <BrandLink href="#inicio" aria-label="Voltar para o topo da página" $scrolled={isScrolled}>
            <BrandLogo src={LogoImage} alt="Logo JR Figurinhas" width="97" height="128" />
            <BrandText $scrolled={isScrolled}>
              <strong>JR Figurinhas</strong>
              <small>Desde 2006 colecionando memórias</small>
            </BrandText>
          </BrandLink>

          <DesktopNav aria-label="Navegação principal">
            {navigationLinks.map((link) => (
              <NavLink key={link.href} href={link.href} $scrolled={isScrolled}>
                {link.label}
              </NavLink>
            ))}
          </DesktopNav>

          <MenuButton
            type="button"
            aria-label="Abrir menu"
            aria-expanded={menuOpen}
            $scrolled={isScrolled}
            onClick={() => setMenuOpen(true)}
          >
            <MenuIcon width="24" height="24" />
          </MenuButton>
        </HeaderInner>
      </Header>

      <MobileMenu $open={menuOpen} aria-hidden={!menuOpen}>
        <MobileMenuPanel $open={menuOpen}>
          <MobileMenuTop>
            <strong>Menu</strong>
            <CloseButton type="button" aria-label="Fechar menu" onClick={closeMenu}>
              ×
            </CloseButton>
          </MobileMenuTop>

          <MobileNav aria-label="Navegação mobile">
            {navigationLinks.map((link) => (
              <MobileNavLink key={link.href} href={link.href} onClick={closeMenu}>
                {link.label}
              </MobileNavLink>
            ))}
          </MobileNav>
        </MobileMenuPanel>
      </MobileMenu>

      <Main>
        <HeroCarouselSection id="inicio">
          <HeroCarouselInner>
            <HeroVisual aria-label="Destaques de JR Figurinhas">
              <HeroFrame>
                <HeroMedia>
                  {heroSlides.map((slide, index) => (
                    <HeroSlide key={slide.alt} $active={index === activeHero} aria-hidden={index !== activeHero}>
                      <HeroPicture>
                        <source media="(max-width: 768px)" srcSet={slide.mobile} />
                        <HeroImage
                          src={slide.desktop}
                          alt={slide.alt}
                          loading={index === 0 ? "eager" : "lazy"}
                          decoding="async"
                          fetchPriority={index === 0 ? "high" : "auto"}
                        />
                      </HeroPicture>
                    </HeroSlide>
                  ))}
                  <HeroBadge>{heroSlides[activeHero].badge}</HeroBadge>
                </HeroMedia>
              </HeroFrame>

              <HeroDots>
                {heroSlides.map((slide, index) => (
                  <HeroDot
                    key={slide.badge}
                    type="button"
                    $active={index === activeHero}
                    aria-label={`Ir para destaque ${index + 1}`}
                    aria-pressed={index === activeHero}
                    onClick={() => setActiveHero(index)}
                  />
                ))}
              </HeroDots>
            </HeroVisual>
          </HeroCarouselInner>
        </HeroCarouselSection>

        <HeroSection>
          <HeroInner>
            <HeroCopy>
              <Eyebrow>Banca especializada em figurinhas</Eyebrow>
              <HeroTitle>Álbuns e figurinhas para completar sua coleção.</HeroTitle>
              <HeroText>
                Em JR Figurinhas você encontra álbuns completos, álbuns vazios,
                figurinhas avulsas e atendimento rápido para fechar a coleção.
              </HeroText>

              <HeroList>
                <HeroListItem>
                  Leve o álbum completo ou comece do zero, do seu jeito.
                </HeroListItem>
                <HeroListItem>
                  Consulte faltantes pelo WhatsApp com atendimento direto da banca.
                </HeroListItem>
                <HeroListItem>
                  Acompanhe o troca-troca e aumente suas chances de fechar o álbum.
                </HeroListItem>
              </HeroList>

              <HeroActions>
                <ButtonLink href={openContactLink} target="_blank" rel="noreferrer">
                  Falar com a loja
                </ButtonLink>
                <ButtonLink href="#completos" $variant="outline">
                  Ver opções de coleção
                </ButtonLink>
              </HeroActions>

              <HeroMeta>
                <MetaPill>Pix e cartão</MetaPill>
                <MetaPill>Entrega rápida</MetaPill>
                <MetaPill>Troca em até 30 dias</MetaPill>
              </HeroMeta>
            </HeroCopy>
          </HeroInner>
        </HeroSection>

        <Section>
          <SectionInner>
            <SectionHeading>
              <SectionTag>Por que comprar aqui</SectionTag>
              <SectionTitle>Atendimento rápido para quem coleciona.</SectionTitle>
              <SectionDescription>
                Álbuns, figurinhas avulsas e suporte direto para você comprar com mais clareza e menos
                enrolação.
              </SectionDescription>
            </SectionHeading>

            <BenefitsGrid>
              {benefits.map(({ title, description, Icon }) => (
                <BenefitCard key={title}>
                  <BenefitIcon aria-hidden="true">
                    <Icon width="34" height="34" />
                  </BenefitIcon>
                  <BenefitTitle>{title}</BenefitTitle>
                  <BenefitText>{description}</BenefitText>
                </BenefitCard>
              ))}
            </BenefitsGrid>
          </SectionInner>
        </Section>

        <Section id="completos">
          <SectionInner>
            <FeatureShell>
              <SectionHeading $light>
                <SectionTag $light>Álbuns completos</SectionTag>
                <SectionTitle $light>Leve o álbum pronto.</SectionTitle>
                <SectionDescription $light>
                  Opções para quem prefere sair com a coleção fechada, com atendimento rápido e confirmação
                  pelo WhatsApp.
                </SectionDescription>
              </SectionHeading>

              <FeatureScrollArea>
                <FeatureStickyShell>
                  <FeatureGrid>
                    <AlbumPreview>
                      <AlbumPreviewLabel>Seleção em destaque</AlbumPreviewLabel>
                      <AlbumPreviewTitle>{selectedAlbum.name}</AlbumPreviewTitle>
                      <AlbumPreviewText>{selectedAlbum.description}</AlbumPreviewText>
                      <AlbumPreviewMedia>
                        <AlbumPreviewImage
                          src={selectedAlbum.src}
                          alt={`Capa do álbum ${selectedAlbum.name}`}
                          loading="lazy"
                          decoding="async"
                        />
                      </AlbumPreviewMedia>
                      <ButtonLink href={fullAlbumLink} target="_blank" rel="noreferrer" $variant="light">
                        Quero meu álbum completo
                      </ButtonLink>
                    </AlbumPreview>

                    <AlbumSelector>
                      <AlbumSelectorIntro>
                        <AlbumSelectorTag $palette={activeAlbumPalette}>Escolha um álbum</AlbumSelectorTag>
                        <AlbumSelectorTitle>Veja os completos disponíveis.</AlbumSelectorTitle>
                        <AlbumSelectorText>
                          Toque em uma opção para atualizar o destaque e consultar o álbum que mais combina
                          com a sua coleção.
                        </AlbumSelectorText>
                      </AlbumSelectorIntro>

                      <AlbumOptions>
                        {teamAlbums.map((album, index) => (
                          <AlbumOption
                            key={album.name}
                            type="button"
                            $active={index === activeAlbum}
                            $palette={getAlbumPalette(index)}
                            aria-label={`Destacar álbum ${album.name}`}
                            aria-pressed={index === activeAlbum}
                            onClick={() => selectAlbum(index)}
                          >
                            <AlbumOptionNumber
                              $active={index === activeAlbum}
                              $palette={getAlbumPalette(index)}
                            >
                              {String(index + 1).padStart(2, "0")}
                            </AlbumOptionNumber>
                            <AlbumOptionThumb>
                              <AlbumOptionImage
                                src={album.src}
                                alt={`Miniatura do álbum ${album.name}`}
                                loading="lazy"
                                decoding="async"
                              />
                            </AlbumOptionThumb>
                            <AlbumOptionContent>
                              <AlbumOptionName>{album.name}</AlbumOptionName>
                              <AlbumOptionDescription $active={index === activeAlbum}>
                                {album.description}
                              </AlbumOptionDescription>
                            </AlbumOptionContent>
                          </AlbumOption>
                        ))}
                      </AlbumOptions>

                      <AlbumSelectorFoot>
                        <AlbumSelectorFootLabel $palette={activeAlbumPalette}>
                          Álbum em evidência
                        </AlbumSelectorFootLabel>
                        <AlbumSelectorFootText>
                          {selectedAlbum.tabLabel}: atendimento rápido para consultar disponibilidade e fechar
                          o pedido pelo WhatsApp.
                        </AlbumSelectorFootText>
                      </AlbumSelectorFoot>
                    </AlbumSelector>
                  </FeatureGrid>
                </FeatureStickyShell>
              </FeatureScrollArea>
            </FeatureShell>
          </SectionInner>
        </Section>

        <Section>
          <SectionInner>
            <SectionHeading>
              <SectionTag>Sua coleção, seu ritmo</SectionTag>
              <SectionTitle>Escolha como completar sua coleção.</SectionTitle>
              <SectionDescription>
                Você pode começar com o álbum vazio ou pedir as faltantes para acelerar o fechamento da
                coleção.
              </SectionDescription>
            </SectionHeading>

            <OfferGrid>
              <OfferCard id="normais">
                <OfferContent>
                  <OfferTag>Álbuns normais</OfferTag>
                  <OfferTitle>Comece sua coleção do seu jeito.</OfferTitle>
                  <OfferText>
                    Leve o álbum vazio e complete no seu ritmo, com apoio da banca para encontrar o que
                    faltar.
                  </OfferText>
                  <OfferList>
                    <OfferListItem>Ideal para quem gosta de completar figurinha por figurinha.</OfferListItem>
                    <OfferListItem>Boa opção para presentear ou começar uma nova coleção.</OfferListItem>
                    <OfferListItem>Atendimento no WhatsApp para disponibilidade e dúvidas.</OfferListItem>
                  </OfferList>
                  <OfferAction>
                    <ButtonLink href={regularAlbumLink} target="_blank" rel="noreferrer">
                      Começar minha coleção
                    </ButtonLink>
                  </OfferAction>
                </OfferContent>
              </OfferCard>

              <OfferCard id="avulsas" $tone="dark">
                <OfferContent>
                  <OfferTag $light>Figurinhas avulsas</OfferTag>
                  <OfferTitle $tone="dark">Feche as faltantes com mais velocidade.</OfferTitle>
                  <OfferText $tone="dark">
                    Envie sua lista e consulte as figurinhas que faltam para fechar o álbum com mais
                    agilidade.
                  </OfferText>
                  <OfferList>
                    <OfferListItem $tone="dark">Envie a sua listagem e agilize a busca.</OfferListItem>
                    <OfferListItem $tone="dark">Boa alternativa para álbuns perto da conclusão.</OfferListItem>
                    <OfferListItem $tone="dark">Mais eficiência para fechar coleções sem perder tempo.</OfferListItem>
                  </OfferList>
                  <OfferAction>
                    <ButtonLink
                      href={singleStickerLink}
                      target="_blank"
                      rel="noreferrer"
                      $variant="light"
                    >
                      Comprar figurinhas
                    </ButtonLink>
                  </OfferAction>
                </OfferContent>
              </OfferCard>
            </OfferGrid>
          </SectionInner>
        </Section>

        <Section id="encontro">
          <SectionInner>
            <SectionHeading>
              <SectionTag>Encontro de colecionadores</SectionTag>
              <SectionTitle>Troca-troca na banca.</SectionTitle>
              <SectionDescription>
                Um ponto de encontro para trocar figurinhas, encontrar faltantes e acompanhar as novidades
                da coleção.
              </SectionDescription>
            </SectionHeading>

            <CommunityGrid>
              <CommunityCard>
                <OfferTag>{meetupCampaignBadge}</OfferTag>
                <OfferTitle>Troca de figurinhas na banca.</OfferTitle>
                <OfferText>
                  A banca reúne colecionadores para trocar figurinhas, buscar faltantes e fechar mais
                  páginas no mesmo dia.
                </OfferText>
                <CommunityHighlights>
                  <CommunityHighlight>
                    <span>
                      <strong>{meetupCampaignHighlightLabel}</strong> {meetupCampaignHighlightText}
                    </span>
                  </CommunityHighlight>
                  <CommunityHighlight>
                    <span>
                      <strong>Ambiente:</strong> espaço para trocar, comprar e tirar dúvidas na hora.
                    </span>
                  </CommunityHighlight>
                  <CommunityHighlight>
                    <span>
                      <strong>Comunidade:</strong> ótimo ponto de encontro para quem leva coleção a sério.
                    </span>
                  </CommunityHighlight>
                </CommunityHighlights>

                <HeroActions>
                  <ButtonLink href={meetupLink} target="_blank" rel="noreferrer">
                    Quero saber do encontro
                  </ButtonLink>
                </HeroActions>
              </CommunityCard>

              <CommunityGalleryShell>
                <CommunityGalleryBadge>Todo sábado • troca ao vivo</CommunityGalleryBadge>
                <CommunityGallery>
                  {communityPhotos.map((photo) => (
                    <CommunityPhoto
                      key={photo.alt}
                      $tall={photo.tall}
                      $wide={photo.wide}
                      $tilt={photo.tilt}
                      $offset={photo.offset}
                      $duration={photo.duration}
                      $delay={photo.delay}
                    >
                      <CommunityPhotoSurface>
                        <CommunityImage
                          src={photo.src}
                          alt={photo.alt}
                          loading="lazy"
                          decoding="async"
                        />
                        <CommunityPhotoCaption>
                          <CommunityPhotoLabel $accent={photo.accent}>
                            {photo.label}
                          </CommunityPhotoLabel>
                          <CommunityPhotoNote>{photo.note}</CommunityPhotoNote>
                        </CommunityPhotoCaption>
                      </CommunityPhotoSurface>
                    </CommunityPhoto>
                  ))}
                </CommunityGallery>
              </CommunityGalleryShell>
            </CommunityGrid>
          </SectionInner>
        </Section>
      </Main>

      <Footer>
        <FooterInner>
          <FooterGrid>
            <FooterBlock>
              <FooterTitle>JR Figurinhas</FooterTitle>
              <FooterText>
                Loja especializada em álbuns, figurinhas avulsas e troca-troca para colecionadores.
              </FooterText>
              <HeroActions>
                <SocialLink
                  href={INSTAGRAM_URL}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram JR Figurinhas"
                >
                  <InstagramIcon width="22" height="22" />
                </SocialLink>
              </HeroActions>
            </FooterBlock>

            <FooterBlock>
              <FooterTitle>Atendimento</FooterTitle>
              <FooterList>
                <FooterItem>Seg a sex, 08h30 às 18h</FooterItem>
                <FooterItem>Sábado, 08h30 às 14h</FooterItem>
                <FooterItem>
                  <a href={openContactLink} target="_blank" rel="noreferrer">
                    WhatsApp: (84) 99928-4464
                  </a>
                </FooterItem>
              </FooterList>
            </FooterBlock>

            <FooterBlock>
              <FooterTitle>Navegação</FooterTitle>
              <FooterNav aria-label="Navegação do rodapé">
                {navigationLinks.map((link) => (
                  <a key={link.href} href={link.href}>
                    {link.label}
                  </a>
                ))}
              </FooterNav>
            </FooterBlock>

            <FooterBlock>
              <FooterTitle>Localização</FooterTitle>
              <MapFrame
                title="Localização de JR Figurinhas"
                src={MAP_EMBED_URL}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </FooterBlock>
          </FooterGrid>

          <FooterBottom>
            © {new Date().getFullYear()} JR Figurinhas - CNPJ: 07.654.034/0001-49. Todos os direitos reservados.
          </FooterBottom>
          <FooterBottom>
            Desenvolvido por{" "}
            <FooterSignatureLink
              href="https://mangosoftwarehouse.com"
              target="_blank"
              rel="noreferrer"
              aria-label="Mango Software House"
            >
              <FooterSignatureLogo src={MangoLogo} alt="Logo da Mango Software House" width="534" height="609" />
            </FooterSignatureLink>
          </FooterBottom>
        </FooterInner>
      </Footer>

      {WORLD_CUP_CAMPAIGN_ENABLED && isWorldCupConfettiRainActive && (
        <WorldCupRainLayer aria-hidden="true">
          {worldCupRainPieces.map((piece, index) => (
            <WorldCupRainConfetti
              key={`${piece.left}-${index}`}
              $left={piece.left}
              $size={piece.size}
              $color={piece.color}
              $drift={piece.drift}
              $rotate={piece.rotate}
              $duration={piece.duration}
              $delay={piece.delay}
              $shape={piece.shape}
              $opacity={piece.opacity}
            />
          ))}
        </WorldCupRainLayer>
      )}

      {WORLD_CUP_CAMPAIGN_ENABLED && isWorldCupBannerOpen && (
        <>
          <WorldCupOverlay onClick={closeWorldCupBanner} />
          <WorldCupOverlayCenter
            role="dialog"
            aria-modal="true"
            aria-labelledby="world-cup-banner-title"
          >
            <WorldCupDialog>
              <WorldCupConfettiLayer aria-hidden="true">
                {worldCupConfettiPieces.map((piece, index) => (
                  <WorldCupConfetti
                    key={`${piece.left}-${index}`}
                    $left={piece.left}
                    $top={piece.top}
                    $size={piece.size}
                    $color={piece.color}
                    $drift={piece.drift}
                    $rotate={piece.rotate}
                    $duration={piece.duration}
                    $delay={piece.delay}
                    $shape={piece.shape}
                  />
                ))}
              </WorldCupConfettiLayer>

              <WorldCupContent>
                <WorldCupCloseButton
                  type="button"
                  aria-label="Fechar banner da campanha da Copa"
                  onClick={closeWorldCupBanner}
                >
                  ×
                </WorldCupCloseButton>
                <WorldCupBadge>JR Figurinhas em clima de Copa</WorldCupBadge>
                <WorldCupTitle id="world-cup-banner-title">A banca já entrou no jogo.</WorldCupTitle>
                <WorldCupText>{WORLD_CUP_BANNER_MESSAGE}</WorldCupText>
                <WorldCupActions>
                  <ButtonLink
                    href={worldCupQuestionsLink}
                    target="_blank"
                    rel="noreferrer"
                    onClick={closeWorldCupBanner}
                  >
                    Tirar dúvidas
                  </ButtonLink>
                  <WorldCupDismissButton type="button" onClick={closeWorldCupBanner}>
                    Fechar aviso
                  </WorldCupDismissButton>
                </WorldCupActions>
              </WorldCupContent>
            </WorldCupDialog>
          </WorldCupOverlayCenter>
        </>
      )}

      <WppBtn />
    </Page>
  );
}

export { Home };
export default Home;
